import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthorizeService } from 'src/app/core/auth/authorize.service';
import { ResourcesService } from 'src/app/shared/services/resources.service';

@Component({
  selector: 'app-not-authorized-facility',
  templateUrl: './not-authorized-facility.component.html',
  styleUrls: ['./not-authorized-facility.component.css']
})
export class NotAuthorizedFacilityComponent implements OnInit, OnDestroy {

  resourceKeyValue: any;
  lblNotAuthorizedInstruction3 = "";
  lblNotAuthorizedInstruction4 = "";

  constructor(
    private authorizeService: AuthorizeService,
    private resourcesService: ResourcesService
    ) {}

  ngOnInit() {

    this.resourcesService.bsObject.subscribe(result => {
      result && (this.resourceKeyValue = result);
      this.setControlValues();

    });

    this.authorizeService.isAuthorizeSubject.next(false);

  }

  ngOnDestroy(): void {
    this.authorizeService.isAuthorizeSubject.next(true);
  }

  setControlValues(): void {
    this.lblNotAuthorizedInstruction3 = this.resourceKeyValue.lblNotAuthorizedInstruction3;
    this.lblNotAuthorizedInstruction4 = this.resourceKeyValue.lblNotAuthorizedInstruction4;
  }
}
